const BASE_URL = process.env.NODE_ENV === "development" ? "http://localhost:8080/" : "https://api.ohcleo.com/";


function makeRequest(method, endpoint, options, onSuccess, onError) {
    var xhr = new XMLHttpRequest();
    xhr.open(method.toUpperCase(), BASE_URL + endpoint, true);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xhr.onload = function (e) {
        if (xhr.readyState === 4) {
            if (xhr.status === 200 && !(xhr.responseText && xhr.responseText.error)) {
                if (onSuccess) onSuccess(xhr.responseText);
            } else {
                if (onError) onError(xhr.responseText);
            }
        }
    };
    xhr.onerror = function (e) {
        if (onError) onError(xhr.statusText);
    };
    xhr.withCredentials = false;
    if (method === 'GET') {
        xhr.send();
    } else {
        xhr.send(JSON.stringify(options));
    }
}

exports.makeRequest = makeRequest